export const Z_INDEX = {
	/**
	 * Keeps the tab content above the `secondary` variant's active tab indicator.
	 * Using a number as the indicator's `z-index` needs to be based off this value.
	 */
	tab: 1,
	/**
	 * Used to cover elements that are disabled while providing a message to the user.
	 */
	disabledOverlayMessage: 'z-50',
	/**
	 * Bottom bar fixed to the bottom of the screen on mobile (e.g. tabs, buttons, etc.).
	 */
	mobileBottomBar: 'z-100',
	/**
	 * Applied to the transparent overlay that catches clicks outside the modal.
	 */
	modalOverlay: 'z-130',
	/**
	 * Applied to the styled overlay / container that wraps the modal content.
	 * Should remain one higher than the transparent overlay.
	 */
	modalContainer: 'z-131',
	/**
	 * Popups should have a higher `z-index` than most other elements.
	 * Using a number because `PopupOverlay` by default uses this value - 1.
	 */
	popup: 150,
	toastList: 'z-200',
	/**
	 * Can be within popups and toasts so should remain larger than them.
	 */
	dropdown: 'z-201',
	/**
	 * Can be within a dropdown so should remain larger than it.
	 * Using a number because the tooltip uses an overlay with this value - 1.
	 */
	tooltip: 202,
	/**
	 * Should be above all other elements.
	 */
	tvFullScreenChart: 'z-999999',
} as const;
